module.exports = __webpack_public_path__ + "img/777.b0524a33.png";